export const THEME_STORAGE_KEY = 'iceiq-theme';
const THEMES = ['light', 'dark'];

// Storage can throw (private mode, blocked site data); treat that as "no choice stored".
export function getStoredTheme(storage) {
  if (!storage) return null;
  try {
    const stored = storage.getItem(THEME_STORAGE_KEY);
    return THEMES.includes(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function resolveTheme(stored, systemPrefersDark) {
  return stored ?? (systemPrefersDark ? 'dark' : 'light');
}

export function storeTheme(storage, value) {
  if (!storage) return;
  try {
    storage.setItem(THEME_STORAGE_KEY, value);
  } catch {
    // The choice still applies for this visit; it just won't persist.
  }
}

// Accessing window.localStorage itself can throw (e.g. SecurityError when
// site data is blocked), unlike a call to one of its methods — so this
// guards the property access, not just getItem/setItem.
export function safeLocalStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function applyThemeAttribute(root, value) {
  root.dataset.theme = value === 'dark' ? 'dark' : 'light';
}
